import { ArrowDown } from "lucide-react";

export default function Funnel({ stats }) {
  const steps = [
    { label: "Leads In", value: stats.total_leads, color: "bg-sky-500", rate: null },
    { label: "Calls Scheduled", value: stats.calls_scheduled, color: "bg-blue-500", rate: stats.rates.lead_to_call },
    { label: "Calls Completed", value: stats.calls_completed, color: "bg-[#4690d9]", rate: stats.rates.call_to_completed },
    { label: "Closed Won", value: stats.closed_won, color: "bg-emerald-500", rate: stats.rates.completed_to_won },
  ];
  const max = Math.max(stats.total_leads, 1);

  return (
    <div className="glass-panel p-6 fade-up" data-testid="conversion-funnel">
      <p className="eyebrow mb-1">Conversion Waterfall</p>
      <h2 className="text-lg font-bold text-white mb-5">Lead → Close Funnel</h2>
      <div className="space-y-1">
        {steps.map((s, i) => (
          <div key={s.label}>
            {i > 0 && (
              <div className="flex items-center gap-2 py-1 pl-2 text-[11px] font-mono-tech text-slate-500">
                <ArrowDown size={12} className="text-[#4690d9]/70" />
                <span className="text-[#9cc6f0]">{s.rate}%</span> conversion
              </div>
            )}
            <div className="flex items-center gap-3" data-testid={`funnel-step-${i}`}>
              <div className="w-32 shrink-0 text-sm text-slate-300 font-medium">{s.label}</div>
              <div className="flex-1 h-8 rounded-md bg-black/30 overflow-hidden">
                <div
                  className={`h-full ${s.color} rounded-md transition-all duration-700 flex items-center justify-end pr-2`}
                  style={{ width: `${Math.max((s.value / max) * 100, s.value > 0 ? 8 : 0)}%` }}
                />
              </div>
              <div className="w-10 text-right font-mono-tech font-bold text-white">{s.value}</div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-5 font-mono-tech uppercase tracking-wider">
        Overall lead → close: <span className="text-emerald-400">{stats.rates.lead_to_won}%</span>
      </p>
    </div>
  );
}
